import HeaderComponent, { MobileHeader as MobileH, DesktopHeader as DesktopH } from './components/header';
import HeaderP25Component, { DesktopHeaderP25 as DesktopHeaderP25H } from './components/header/p25';
import FooterComponent, { MobileFooter as MobileF, DesktopFooter as DesktopF } from './components/footer';
import intl from 'preact-i18n';
import definition from './intl.json';

function intlWrap(Child) {
	return intl(Child, {
		scope: 'header-widget',
		definition
	});
}

export default intlWrap(HeaderComponent);

export const MobileHeader = intlWrap(MobileH);
export const DesktopHeader = intlWrap(DesktopH);

// P25 Header exports
export const HeaderP25 = intlWrap(HeaderP25Component);
export const DesktopHeaderP25 = intlWrap(DesktopHeaderP25H);

export const Footer = intlWrap(FooterComponent);
export const MobileFooter = intlWrap(MobileF);
export const DesktopFooter = intlWrap(DesktopF);
